<template>
  <div class="right-container">
    <!-- <span>苏州驰声信息科技有限公司 Copyright © 2020 All Rights Reserved.</span> -->
    <span
      >承办单位：<a
        href="https://www.chivox.com/"
        target="_blank"
        style="color: #999999"
      >
        苏州驰声信息科技有限公司</a
      ></span
    >
    <span>
      <a
        href="https://www.beian.suzhou.gov.cn/websiteMark?siteid=1219468903546093568&amp;type=1"
        target="_blank"
        style="color: #999999"
      >
        <img
          style="height: 22px; width: 18px; vertical-align: middle"
          src="@/assets/home/szicbok.gif"
        />
      </a>
    </span>
    <span>
      <a
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        style="color: #999999"
      >
        苏ICP备14027754号-6</a
      >
    </span>
    <span>
      <a
        href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32059002002934"
        target="_blank"
        style="color: #999999"
      >
        <img
          style="
            height: 18px;
            width: 18px;
            vertical-align: middle;
            margin-top: -4px;
          "
          src="@/assets/home/foot-icp2.png"
        />
        苏公网安备 32059002002934号</a
      >
    </span>
  </div>
</template>

<script>
export default {};
</script>
<style lang="less" scoped>
.right-container {
  height: 61px;
  background-color: #3e3e3e;
  text-align: center;
  font-size: 14px;
  color: #939aa2;
  span {
    line-height: 61px;
    margin-right: 5px;
  }
}
</style>
